import { render, staticRenderFns } from "./NormalSearchNav235.vue?vue&type=template&id=56ab5be6&scoped=true"
import script from "./NormalSearchNav235.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav235.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab5be6",
  null
  
)

export default component.exports